import { type RuleType } from '@/types/schema/rules/RuleType';
import { blankOperators, isOperators, timeComparisonOperators } from './DefaultOperator';

export const timeOperators = [...isOperators, ...timeComparisonOperators, ...blankOperators];

export const dateTimeOperators = [
  ...isOperators,
  ...timeComparisonOperators,
  'is during the current',
  'is during the previous',
  'is during the next',
  'is during the last',
  'is before the previous',
  'is after the next',
  'is today',
  'is today or before',
  'is today or after',
  'is before today',
  'is after today',
  ...blankOperators
] as const;

export const dateTimeValidationOperators = [
  ...dateTimeOperators,
  'is a day of the week',
  'is between days of the week',
  'is between dates',
  'is a future date',
  'is not a future date'
] as const;

export type DateTimeOperator = (typeof dateTimeOperators)[number];

// As more rule types are introduced into the code, this will need to be updated to reflect the necessary conditionals
export type DateTimeRuleOperator<T extends RuleType> =
  | (T extends 'validation' ? (typeof dateTimeValidationOperators)[number] : DateTimeOperator)
  | (T extends 'conditional' ? DateTimeOperator : never);
